import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { Link } from "react-router-dom";
import { rozhanaRowKey, centerRowInScroller } from "../../../util/rozhanaRow";

class ScroollTableRozhana extends React.Component {
  // Which row the table has already scrolled to. The mark on the last opened
  // پسولە (d_activeRow) survives the trip to its invoice, but the table body is
  // its own scroll container and remounts at the top — so without this the row
  // comes back highlighted yet off-screen.
  scrolledTo = null;

  // Stable identity: React then calls it only when the marked row mounts or
  // unmounts, not on every re-render.
  markActiveRow = (node) => {
    if (!node) return;
    const key = node.dataset.rowKey;
    if (this.scrolledTo === key) return;
    this.scrolledTo = key;
    centerRowInScroller(node, ".JM");
  };

  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const {
              d_dataRozhana,
              D_gotowaslrentsearch,
              D_gotowaslparasearch,
              D_gotowaslGaranawasearch,
              RT_gotoParadanakan,
              RT_gotoMandub,
              JK_kompanyakan,
              d_activeRow,
              D_markActiveRow
            } = value;
            const raportyRozhana = d_dataRozhana.map((user, i) => {
              const rowKey = rozhanaRowKey(user.code, user.jwlla);
              const isActive = !!d_activeRow && d_activeRow === rowKey;
              return (
                <tr
                  key={i}
                  className=""
                  data-row-key={rowKey}
                  ref={isActive ? this.markActiveRow : null}
                  style={{
                    backgroundColor: `${isActive ? "#cdd8ad" : ""}`
                  }}
                >
                  <td
                    className={` fk ${
                      user.jorefroshtn == "فرۆشتنی ڕاستەوخۆ" ? "bg-danger" : ""
                    }`}
                    style={{ border: "2px solid #f0ad4e" }}
                  >
                    {user.zh_wakil}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.nawi_wakil}
                  </td>
                  <td
                    style={{ border: "2px solid #f0ad4e" }}
                    className="fk bg-danger text-white"
                  >
                    <NumberFormat
                      value={user.paraymawa}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    style={{ border: "2px solid #f0ad4e" }}
                    className="fk bg-success text-white"
                  >
                    <NumberFormat
                      value={user.paraydraw}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={user.kmkrdnawa}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    style={{ border: "2px solid #f0ad4e" }}
                    className={`fk ${
                      user.joripara == "دۆلار"
                        ? "dark-green"
                        : user.joripara == "دینار"
                        ? "dark-red"
                        : "dark-blue"
                    }`}
                  >
                    {user.joripara}
                    {user.joripara_dolar || user.joripara_IQD ?  2: null}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.koywasl))
                          ? Number(user.koywasl)
                          : Number(user.koywasl).toFixed(2)
                      }
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      border: "2px solid #f0ad4e",
                      color: `${
                        user.jwlla == "گەڕانەوەی قەرز"
                          ? " #0000b3"
                          : user.jwlla == "گەڕانەوەی کاڵا"
                          ? " #cc6600"
                          : user.jwlla == "پارەدان"
                          ? "#176B76"
                          : user.jwlla == "مافی.کۆمپانیا"
                          ? "#761769"
                          : ""
                      }`
                    }}
                  >
                    {user.jwlla}
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    <Time
                      value={user.barwar}
                      format="YYYY-MM-DD"
                      style={{ color: "black" }}
                    />
                  </td>
                  {JK_kompanyakan ? (
                    <>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        {user.nrxe_RRR}
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        {user.Krini_RRR}
                      </th>
                    </>
                  ) : null}
                  <td
                    className="fk"
                    style={{
                      border: "2px solid #f0ad4e",
                      cursor: "pointer",
                      // The row background is hidden behind the coloured cells,
                      // so the پسولە itself carries the mark too — that is the
                      // cell the user clicked and comes back looking for.
                      backgroundColor: isActive ? "#f0ad4e" : "",
                      fontWeight: isActive ? "bold" : ""
                    }}
                    onClick={(e) => {
                      D_markActiveRow(user.code, user.jwlla);
                      user.jwlla == "فرۆشتن"
                        ? D_gotowaslrentsearch(e, user.code, i)
                        : user.jwlla == "گەڕانەوەی قەرز"
                        ? D_gotowaslparasearch(e, user.code, i)
                        : user.jwlla == "گەڕانەوەی کاڵا"
                        ? D_gotowaslGaranawasearch(e, user.code, i)
                        : user.jwlla == "پارەدان"
                        ? RT_gotoParadanakan(e, user.code, i)
                        : RT_gotoMandub(e, user.code, i);
                    }}
                  >
                    {localStorage.getItem("saledata") ? (
                      <span style={{ color: "red" }}>{user.code}</span>
                    ) : (
                      <Link
                        to={`${
                          user.jwlla == "فرۆشتن"
                            ? "/rent"
                            : user.jwlla == "گەڕانەوەی قەرز"
                            ? "/take-money"
                            : user.jwlla == "گەڕانەوەی کاڵا"
                            ? "/back-koga"
                            : user.jwlla == "پارەدان"
                            ? "/Paradan"
                            : "/Mandub"
                        }`}
                      >
                        {user.code}
                      </Link>
                    )}
                  </td>
                </tr>
              );
            });

            return (
              <div className="JM">
                <table className="table text-right f4 fk">
                  <thead>
                    <tr
                      className="text-warning f4"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <th style={{ border: "2px solid #f0ad4e" }}>وکیل</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        ناوی وەکیل
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        پارەی ماوە{" "}
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        پارەی دراو
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>داشکان</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>دراو</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        کۆی پسوولە
                      </th>
                      {JK_kompanyakan ? (
                        <>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            RR نرخی
                          </th>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            RRR کرینی
                          </th>
                        </>
                      ) : null}
                      <th style={{ border: "2px solid #f0ad4e" }}>جوولە</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>بەروار</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>پسولە</th>
                    </tr>
                  </thead>
                  <tbody>{raportyRozhana}</tbody>
                </table>
              </div>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default ScroollTableRozhana;
